export default {
    "": "Trống",
    "cdhdt": "Cứu đơn hủy đơn trùng",
    "cdr": "Cứu đơn return",
    "dr": "Đơn reorder",
    "dgd": "Đơn gọi delivered",
    "fds": "Failed Delivery Shipment",
    "k": "Khác",
}
